import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import links from 'utils/links';
import { Link } from 'react-router-dom';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  media: {
    height: 400,
  },
  about_body: {
    margin: theme.spacing.unit,
  },
  sec_para: {
    marginTop: theme.spacing.unit,
  },
  readmore: {
    marginTop: theme.spacing.unit,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  paramode: {
    marginTop: theme.spacing.unit + 7,
  },
});

class AboutUs extends React.Component {
  readMore = e => {};
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <CardMedia
              className={classes.media}
              image="/img/Pav_Bhaji_Talking_Street.JPG"
              title="about us hero"
            />
          </Grid>
          <Grid item className={classes.about_body} xs={12}>
            <Typography component="h5" variant="h5">
              About Us
            </Typography>
            <Typography
              className={classes.paramode}
              component="h6"
              variant="body1"
            >
              Fresh gozlemes hot off the girdle, stuffed with tomatoes and feta
              cheese, at a small Turkish eatery in Berlin. Delicately flavoured
              grattachecca in a locally-loved ice-cream parlour on the banks of
              the river Tiber in Rome. Learning about how coffee is made
              starting from picking ripe beans to roasting, in a coffee
              plantation in Coorg, India. Meeting passionate restaurant owners
              of decades-old eateries serving local delicacies in Goa, India.
            </Typography>
            <Typography
              className={classes.sec_para}
              component="h6"
              variant="body1"
            >
              What’s common to these delightful food experiences is that each of
              them was discovered because of a local foodie’s recommendation or
              guidance. What’s also common to each of them is that they were the
              inspiration behind Talking Street.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <CardMedia
              className={classes.media}
              image="/img/TSXmas_Dec18_249.JPG"
              title="about us"
            />
          </Grid>
          <Grid item className={classes.about_body} xs={12}>
            <Typography component="h5" variant="h5">
              Our Story
            </Typography>
            <Typography
              className={classes.paramode}
              component="h6"
              variant="body1"
            >
              We’re travelers and we’re foodies. We’re what we call traveling
              foodies. We love meeting new people and seeing new places but the
              most memorable of our experiences have involved meeting a local
              friend, often through Couchsurfing, who was happy to give us an
              insight into the local culture. And this held true most when it
              came to the food. For a traveling foodie, nothing can be more
              heart-warming than finding a local foodie to chat with, someone
              who they can ask for recommendations on where to eat, someone who
              will point them to the hidden jewels when it comes to food.
            </Typography>
            <Typography
              className={classes.paramode}
              component="h6"
              variant="body1"
            >
              And since no one was doing this, we thought, why not us. So,
              Talking Street. Your local foodie friend across cities.
            </Typography>
            <Typography
              className={classes.paramode}
              component="h6"
              variant="body1"
            >
              Over conversations and delicious food, many travelers told us that
              food is always on their minds when they travel. Infact, according
              to a survey, 51% of travelers want to try local food when they
              travel.
            </Typography>
            <Typography
              className={classes.paramode}
              component="h6"
              variant="body1"
            >
              And hence Talking Street. The friend who points you to
              locally-loved eateries, expert foodies and delightful culinary
              experiences with the help of our Food Punfits and their unbiased,
              food-fueled recommendations. Go on, explore dishes, cuisines and
              food culture and discover immersive experiences that you can be
              part of to gain deeper insights.
            </Typography>
            {/* <Typography component="h6" variant="body1">
              <div
                className={classes.readmore}
                onClick={e => {
                  this.readMore();
                }}
              >
                READ MORE
                <img src={'/icons/right-arrow.png'} alt="our story" />
              </div>
            </Typography> */}
          </Grid>

          <Grid item xs={12}>
            <CardMedia
              className={classes.media}
              image="/img/e9.png"
              title="our team"
            />
          </Grid>
          <Grid item className={classes.about_body} xs={12}>
            <Typography component="h5" variant="h5">
              Our team
            </Typography>
            <Typography
              className={classes.paramode}
              component="h6"
              variant="body1"
            >
              Talking Street is a labour of love built line by line, experience
              by experience, city by city by gastronomes who are excited to
              enrich your life with great food experiences.
            </Typography>
            <Link to={links.staticLink('team')}>
              <Typography component="h6" variant="body1">
                <div
                  className={classes.readmore}
                  onClick={e => {
                    this.readMore();
                  }}
                >
                  OUR TEAM
                  <div className={classes.arrowicon} />
                  <img src={'/icons/right-arrow.png'} alt="our team" />
                </div>
              </Typography>
            </Link>
          </Grid>

          <Grid item className={classes.about_body} xs={12}>
            <Typography component="h5" variant="h5">
              Talking Street Community
            </Typography>
            <Typography
              className={classes.paramode}
              component="h6"
              variant="body1"
            >
              Our community is built on the common obsession for delightful
              food. Our Pundits are experts on restaurants, dishes, cuisines,
              and experiences, coming together to share their insights and
              knowledge.
            </Typography>
            <Typography component="h6" variant="body1">
              <div
                className={classes.readmore}
                onClick={e => {
                  this.readMore();
                }}
              >
                <a href="/community">OUR COMMUNITY </a>
                <a href="/community">
                  <img
                    src={'/icons/right-arrow.png'}
                    alt="Talkingstreet community"
                  />
                </a>
              </div>
            </Typography>
          </Grid>
        </Grid>
      </div>
    );
  }
}

AboutUs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AboutUs);
